App.SipBarComponent = Em.Component.extend
  classNames: [ 'sip-bar' ]

  classNameBindings: [ 'isEnabled:-visible', '_isHidden:-hidden' ]

  attributeBindings: [ 'title' ]

  sipService: Em.inject.service('sip')
  env:        Em.inject.service('environment')

  isEnabledBinding: 'sipService.sipEnabled'

  _isHidden: true

  isEnabledChanged: (->
    if @get('isEnabled')
      @set('_isHidden', false)
    else
      Em.run.later =>
        @set('_isHidden', true)
      , 300

  ).observes('isEnabled').on('init')

  click: ->
    @sendAction 'onClick'

  title: (->
    state = @get('sipService.sipState')
    error = @get('sipService.sipError')

    return null unless state is 'error'
    @get('env').translate("sip.error.#{error}")
  ).property(
    'sipService.sipState',
    'sipService.sipError')

  statusText: (->
    state = @get('sipService.sipState')
    @get('env').translate("sip.status.#{state}")
  ).property('sipService.sipState')

